import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  SuccessBackButton,
  SuccessDescription,
  SuccessPanel,
  SuccessTextContainer,
  SuccessTitle
} from "./ProfileMfaConfig.styles";

export function ConfigureTotpModalSuccess({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <SuccessPanel>
      <ShieldCheck
        aria-hidden
        color="currentColor"
        size={ 42 }
        strokeWidth={ 1.8 }
      />

      <SuccessTextContainer>
        <SuccessTitle>
          { t("profile_mfa_success_title") }
        </SuccessTitle>
        <SuccessDescription>
          { t("profile_mfa_success_description") }
        </SuccessDescription>
      </SuccessTextContainer>

      <SuccessBackButton
        variant="text"
        onClick={ onClose }
      >
        { t("profile_mfa_back_to_profile") }
      </SuccessBackButton>
    </SuccessPanel>
  );
}
